import React from 'react';
import { useTranslation } from 'react-i18next';
import { Megaphone } from 'lucide-react';

/* Temporary homepage strip. Put up on 4 Sept 2026 for four weeks — it removes
   itself after the date below, no deploy needed. */
const SHOW_UNTIL = new Date('2026-10-02T18:30:00Z'); // 3 Oct 2026, 00:00 IST

export function HomeAnnouncement() {
  const { t } = useTranslation('homepage');
  if (Date.now() > SHOW_UNTIL.getTime()) return null;

  return (
    <div className="bg-graphite-900 text-white" data-testid="home-announcement">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-2.5 sm:gap-3">
        <span className="hidden sm:inline-flex w-6 h-6 rounded-full bg-amber-500/20 items-center justify-center shrink-0">
          <Megaphone size={13} className="text-amber-500" />
        </span>
        <span className="inline-flex items-center gap-1.5 h-5 px-2 rounded-full bg-amber-500 text-[10px] font-bold uppercase tracking-[0.12em] shrink-0">
          <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
          {t('announcement.badge')}
        </span>
        <p className="text-[13px] sm:text-sm leading-snug text-center" data-testid="home-announcement-text">
          <span className="font-bold text-amber-500">{t('announcement.headline')}</span>
          <span className="hidden sm:inline text-white/40 mx-2">—</span>
          <span className="block sm:inline text-white/85">{t('announcement.body')}</span>
        </p>
      </div>
    </div>
  );
}
